<template>
  <div class="mt-3">
    <div class="home-moving-title font-class">[辦公室搬運服務]</div>
    <div class="mt-3rem mb-5rem">
      <v-form v-model="valid" ref="form" class="form"  lazy-validation>
        <input-container
          ref="inputContainer"
          :configs="inputConfigs"
        ></input-container>
        <p class="text-h5">
          特別聲明：因為本公司所能承擔的賠償責任有限（賠償責任最高為搬運費的15%），要想在搬運過程中或存倉期間萬一因意外地損壞或遺失的物 品得到最大賠償，我們建議客人在搬運前購買搬運或家居保險。
        </p>
        <p class="text-h5">
          Declaration：The company can bear limited liability (compensation liability is up to 15% of the total service fee of removal). If more comprehensive protection is required (including the removal process and storage), it is recommended that customers purchase insurance before removal.
        </p>
        <v-btn
          x-large
          dark
          color="rgba(54,77,137,1)"
          rounded
          @click="submit"
        >
          <div class="ml-10 mr-10 text-h5">發送 Submit</div>
        </v-btn>
      </v-form>
      <form-editor
        :show="debug"
        :inputConfigs="inputConfigs"
        @update="updateConfig"
      ></form-editor>
    </div>
    <span v-if="!isMobile">
      <BackToTop target="" ref="backToTop"></BackToTop>
      <WhatsappBtn
        whatsappNumber="85264184666"
      ></WhatsappBtn>
    </span>
  </div>
</template>

<style scoped>
  .mt-3rem{
    margin-top: 3rem;
  }
  .mb-5rem{
    margin-bottom: 5rem;
  }
  .font-class{
    white-space: nowrap;
    text-align: left;
    font-family: Source Han Sans HK;
    font-style: normal;
  }
  .home-moving-title{
    font-weight: bold;
    font-size: 45px;
    color: rgba(54,77,137,1);
  }
</style>

<script>
import common from '@/components/mixin/common'
import { sendOfficeMovingEmail } from '@/api/email'
import FormEditor from '@/components/CRUD/FormEditor'
import InputContainer from '@/components/CRUD/InputContainer'
import BackToTop from '@/components/BackToTop'
import WhatsappBtn from '@/components/WhatsappBtn'
export default {
  name: 'OfficeMoving',
  mixins: [common],
  components: {
    InputContainer,
    FormEditor,
    BackToTop,
    WhatsappBtn
    // UniversalInput
  },
  methods: {
    submit () {
      if (this.$refs.inputContainer) {
        if (this.$refs.form.validate()) {
          if (this.valid) {
            console.log('this.$refs.inputContainer.editedItem', this.$refs.inputContainer.editedItem)
            // return this.$refs.inputContainer.editedItem
            // return this.$refs.inputContainer.editedItem
            sendOfficeMovingEmail(this.$refs.inputContainer.editedItem).then((response) => {
              console.log(response)
              window.alert('Order sent to Champion Moving. A copy would sent to email with aboth address for reference.')
            }).catch((error) => {
              console.log(error)
              window.alert('Error occur. Please contact support.')
            })
          }
        } else {
          window.alert('Please fill in the required information.')
          this.$refs.backToTop.backToTop()
        }
      } else {
        console.log('this.$refs.inputContainer', this.$refs.inputContainer)
      }
    },
    updateConfig (configs) {
      this.inputConfigs = configs
    }
  },
  mounted () {
    this.inputConfigsString = JSON.stringify(this.inputConfigs, null, 4)
  },
  props: {
    debug: {
      default: false,
      type: Boolean
    }
  },
  data () {
    return {
      valid: true,
      inputConfigs: [
        {
          md: 12,
          sm: 12,
          sectionTitle: '聯絡資料 Information'
        },
        {
          md: 4,
          offsetRightMd: 8,
          propName: 'companyName',
          toplabel: '公司名稱 Company Name',
          type: {
            required: true,
            rules: [
              value => !!value
            ]
          }
        },
        {
          md: 4,
          offsetRightMd: 8,
          propName: 'clientName',
          toplabel: '連絡人姓名 Contact Person',
          type: {
            required: true,
            rules: [
              value => !!value
            ]
          }
        },
        {
          md: 4,
          offsetRightMd: 8,
          propName: 'clientPhone',
          toplabel: '手提電話 Mobile Number',
          type: {
            required: true,
            rules: [
              value => !!value
            ]
          }
        },
        {
          md: 4,
          offsetRightMd: 8,
          propName: 'email',
          toplabel: '電郵 Email'
        },
        {
          md: 6,
          offsetRightMd: 6,
          propName: 'currentAddress',
          toplabel: '舊地址 Current Address',
          type: {
            name: 'textarea',
            required: true,
            rules: [
              value => !!value
            ]
          }
        },
        {
          md: 12,
          propName: 'currentAddressInfo',
          toplabel: '舊地址信息 Current Address Info',
          type: {
            name: 'checkbox',
            checkboxItems: [
              {
                itemName: 'noLift',
                label: '沒有電梯 No Lift'
              },
              {
                itemName: 'stairs',
                label: '有樓梯 Internal Stairs'
              },
              {
                itemName: 'exchange',
                label: '需要平台轉𨋢 Needed to exchange the elevator in loading area'
              }
            ]
          }
        },
        {
          md: 6,
          offsetRightMd: 6,
          propName: 'newAddress',
          toplabel: '新地址 New Address',
          type: {
            name: 'textarea',
            required: true,
            rules: [
              value => !!value
            ]
          }
        },
        {
          md: 12,
          propName: 'newAddressInfo',
          toplabel: '新地址信息 New Address Info',
          type: {
            name: 'checkbox',
            checkboxItems: [
              {
                itemName: 'noLift',
                label: '沒有電梯 No Lift'
              },
              {
                itemName: 'stairs',
                label: '有樓梯 Internal Stairs'
              },
              {
                itemName: 'exchange',
                label: '需要平台轉𨋢 Needed to exchange the elevator in loading area'
              }
            ]
          }
        },
        {
          md: 4,
          offsetRightMd: 8,
          propName: 'expectedDate',
          toplabel: '預計搬遷日期 Expected Relocation Date',
          label: 'YYYY-MM-DD',
          type: {
            name: 'datepicker',
            required: true,
            allowedDates: (val) => {
              return val >= new Date().toISOString().substr(0, 10)
            },
            rules: [
              value => !!value
            ]
          }
        },
        {
          md: 12,
          sectionTitle: '寫字枱 Table'
        },
        {
          md: 4,
          propName: 'desk_grand',
          toplabel: '大班檯 Grand Desk',
          label: '請選擇數量',
          type: {
            name: 'select',
            items: [
              {
                label: '請選擇數量',
                id: 0
              },
              {
                label: '1件/pc',
                id: 1
              },
              {
                label: '2件/pcs',
                id: 2
              },
              {
                label: '3件/pcs',
                id: 3
              },
              {
                label: '4件/pcs',
                id: 4
              },
              {
                label: '5件/pcs',
                id: 5
              },
              {
                label: '6件/pcs',
                id: 6
              },
              {
                label: '7件/pcs',
                id: 7
              },
              {
                label: '8件/pcs',
                id: 8
              },
              {
                label: '9件/pcs',
                id: 9
              },
              {
                label: '10件或以上/or more pcs',
                id: 10
              }
            ]
          }
        },
        {
          md: 4,
          propName: 'desk_wx',
          toplabel: '寫字檯連間隔板 Desk wx return wx partition',
          label: '請選擇數量',
          type: {
            name: 'select',
            items: [
              {
                label: '請選擇數量',
                id: 0
              },
              {
                label: '1件/pc',
                id: 1
              },
              {
                label: '2件/pcs',
                id: 2
              },
              {
                label: '3件/pcs',
                id: 3
              },
              {
                label: '4件/pcs',
                id: 4
              },
              {
                label: '5件/pcs',
                id: 5
              },
              {
                label: '6件/pcs',
                id: 6
              },
              {
                label: '7件/pcs',
                id: 7
              },
              {
                label: '8件/pcs',
                id: 8
              },
              {
                label: '9件/pcs',
                id: 9
              },
              {
                label: '10件或以上/or more pcs',
                id: 10
              }
            ]
          }
        },
        {
          md: 4,
          propName: 'desk_ordinary',
          toplabel: '普通寫字檯 Ordinary Desk',
          label: '請選擇數量',
          type: {
            name: 'select',
            items: [
              {
                label: '請選擇數量',
                id: 0
              },
              {
                label: '1-10件/pcs',
                id: 1
              },
              {
                label: '11-20件/pcs',
                id: 2
              },
              {
                label: '21-30件/pcs',
                id: 3
              },
              {
                label: '31-40件/pcs',
                id: 4
              },
              {
                label: '41-50件/pcs',
                id: 5
              },
              {
                label: '51-60件/pcs',
                id: 6
              },
              {
                label: '61-70件/pcs',
                id: 7
              },
              {
                label: '71-80件/pcs',
                id: 8
              },
              {
                label: '81-90件/pcs',
                id: 9
              },
              {
                label: '91-100件/pcs',
                id: 10
              },
              {
                label: '100件或以上/or more pcs',
                id: 11
              }
            ]
          }
        },
        {
          md: 4,
          propName: 'desk_wxl',
          toplabel: 'L 型寫字檯連間隔板 L-Shape Executive Desk wx partition',
          label: '請選擇數量',
          type: {
            name: 'select',
            items: [
              {
                label: '請選擇數量',
                id: 0
              },
              {
                label: '1件/pc',
                id: 1
              },
              {
                label: '2件/pcs',
                id: 2
              },
              {
                label: '3件/pcs',
                id: 3
              },
              {
                label: '4件/pcs',
                id: 4
              },
              {
                label: '5件/pcs',
                id: 5
              },
              {
                label: '6件/pcs',
                id: 6
              },
              {
                label: '7件/pcs',
                id: 7
              },
              {
                label: '8件/pcs',
                id: 8
              },
              {
                label: '9件/pcs',
                id: 9
              },
              {
                label: '10件或以上/or more pcs',
                id: 10
              }
            ]
          }
        },
        {
          md: 4,
          propName: 'desk_l',
          toplabel: 'L 寫字檯 L-Shape Executive Desk',
          label: '請選擇數量',
          type: {
            name: 'select',
            items: [
              {
                label: '請選擇數量',
                id: 0
              },
              {
                label: '1件/pc',
                id: 1
              },
              {
                label: '2件/pcs',
                id: 2
              },
              {
                label: '3件/pcs',
                id: 3
              },
              {
                label: '4件/pcs',
                id: 4
              },
              {
                label: '5件/pcs',
                id: 5
              },
              {
                label: '6件/pcs',
                id: 6
              },
              {
                label: '7件/pcs',
                id: 7
              },
              {
                label: '8件/pcs',
                id: 8
              },
              {
                label: '9件/pcs',
                id: 9
              },
              {
                label: '10件或以上/or more pcs',
                id: 10
              }
            ]
          }
        },
        {
          md: 4,
          propName: 'table_conference',
          toplabel: '大會議檯 Conference Table',
          label: '請選擇數量',
          type: {
            name: 'select',
            items: [
              {
                label: '請選擇數量',
                id: 0
              },
              {
                label: '1件/pc',
                id: 1
              },
              {
                label: '2件/pcs',
                id: 2
              },
              {
                label: '3件/pcs',
                id: 3
              },
              {
                label: '4件/pcs',
                id: 4
              },
              {
                label: '5件/pcs',
                id: 5
              },
              {
                label: '6件/pcs',
                id: 6
              },
              {
                label: '7件/pcs',
                id: 7
              },
              {
                label: '8件/pcs',
                id: 8
              },
              {
                label: '9件/pcs',
                id: 9
              },
              {
                label: '10件或以上/or more pcs',
                id: 10
              }
            ]
          }
        },
        {
          md: 4,
          propName: 'table_folding',
          toplabel: '摺檯 Folding table',
          label: '請選擇數量',
          type: {
            name: 'select',
            items: [
              {
                label: '請選擇數量',
                id: 0
              },
              {
                label: '1-10件/pcs',
                id: 1
              },
              {
                label: '11-20件/pcs',
                id: 2
              },
              {
                label: '21-30件/pcs',
                id: 3
              },
              {
                label: '31-40件/pcs',
                id: 4
              },
              {
                label: '41-50件/pcs',
                id: 5
              },
              {
                label: '51-60件/pcs',
                id: 6
              },
              {
                label: '61-70件/pcs',
                id: 7
              },
              {
                label: '71-80件/pcs',
                id: 8
              },
              {
                label: '81-90件/pcs',
                id: 9
              },
              {
                label: '91-100件/pcs',
                id: 10
              },
              {
                label: '100件或以上/or more pcs',
                id: 11
              }
            ]
          }
        },
        {
          md: 12,
          sectionTitle: '櫃 Cabinet'
        },
        {
          md: 4,
          propName: 'cabinet_tall',
          toplabel: '文件櫃(高) File Cabinet (Tall)',
          label: '請選擇數量',
          type: {
            name: 'select',
            items: [
              {
                label: '請選擇數量',
                id: 0
              },
              {
                label: '1件/pc',
                id: 1
              },
              {
                label: '2件/pcs',
                id: 2
              },
              {
                label: '3件/pcs',
                id: 3
              },
              {
                label: '4件/pcs',
                id: 4
              },
              {
                label: '5件/pcs',
                id: 5
              },
              {
                label: '6件/pcs',
                id: 6
              },
              {
                label: '7件/pcs',
                id: 7
              },
              {
                label: '8件/pcs',
                id: 8
              },
              {
                label: '9件/pcs',
                id: 9
              },
              {
                label: '10件或以上/or more pcs',
                id: 10
              }
            ]
          }
        },
        {
          md: 4,
          propName: 'cabinet_short',
          toplabel: '文件櫃(矮) File Cabinet (Short)',
          label: '請選擇數量',
          type: {
            name: 'select',
            items: [
              {
                label: '請選擇數量',
                id: 0
              },
              {
                label: '1件/pc',
                id: 1
              },
              {
                label: '2件/pcs',
                id: 2
              },
              {
                label: '3件/pcs',
                id: 3
              },
              {
                label: '4件/pcs',
                id: 4
              },
              {
                label: '5件/pcs',
                id: 5
              },
              {
                label: '6件/pcs',
                id: 6
              },
              {
                label: '7件/pcs',
                id: 7
              },
              {
                label: '8件/pcs',
                id: 8
              },
              {
                label: '9件/pcs',
                id: 9
              },
              {
                label: '10件或以上/or more pcs',
                id: 10
              }
            ]
          }
        },
        {
          md: 4,
          propName: 'cabinet_long',
          toplabel: '長地櫃 Long Cabinet',
          label: '請選擇數量',
          type: {
            name: 'select',
            items: [
              {
                label: '請選擇數量',
                id: 0
              },
              {
                label: '1件/pc',
                id: 1
              },
              {
                label: '2件/pcs',
                id: 2
              },
              {
                label: '3件/pcs',
                id: 3
              },
              {
                label: '4件/pcs',
                id: 4
              },
              {
                label: '5件/pcs',
                id: 5
              },
              {
                label: '6件/pcs',
                id: 6
              },
              {
                label: '7件/pcs',
                id: 7
              },
              {
                label: '8件/pcs',
                id: 8
              },
              {
                label: '9件/pcs',
                id: 9
              },
              {
                label: '10件或以上/or more pcs',
                id: 10
              }
            ]
          }
        },
        {
          md: 4,
          propName: 'drawer3',
          toplabel: '小路寶 3 Drawer Mobile Pedestal',
          label: '請選擇數量',
          type: {
            name: 'select',
            items: [
              {
                label: '請選擇數量',
                id: 0
              },
              {
                label: '1-10件/pcs',
                id: 1
              },
              {
                label: '11-20件/pcs',
                id: 2
              },
              {
                label: '21-30件/pcs',
                id: 3
              },
              {
                label: '31-40件/pcs',
                id: 4
              },
              {
                label: '41-50件/pcs',
                id: 5
              },
              {
                label: '51-60件/pcs',
                id: 6
              },
              {
                label: '61-70件/pcs',
                id: 7
              },
              {
                label: '71-80件/pcs',
                id: 8
              },
              {
                label: '81-90件/pcs',
                id: 9
              },
              {
                label: '91-100件/pcs',
                id: 10
              },
              {
                label: '100件或以上/or more pcs',
                id: 11
              }
            ]
          }
        },
        {
          md: 4,
          propName: 'bookshelf',
          toplabel: '書架 Bookshelf',
          label: '請選擇數量',
          type: {
            name: 'select',
            items: [
              {
                label: '請選擇數量',
                id: 0
              },
              {
                label: '1件/pc',
                id: 1
              },
              {
                label: '2件/pcs',
                id: 2
              },
              {
                label: '3件/pcs',
                id: 3
              },
              {
                label: '4件/pcs',
                id: 4
              },
              {
                label: '5件/pcs',
                id: 5
              },
              {
                label: '6件/pcs',
                id: 6
              },
              {
                label: '7件/pcs',
                id: 7
              },
              {
                label: '8件/pcs',
                id: 8
              },
              {
                label: '9件/pcs',
                id: 9
              },
              {
                label: '10件或以上/or more pcs',
                id: 10
              }
            ]
          }
        },
        {
          md: 4,
          propName: 'sideboard',
          toplabel: '地櫃 Sideboard',
          label: '請選擇數量',
          type: {
            name: 'select',
            items: [
              {
                label: '請選擇數量',
                id: 0
              },
              {
                label: '1件/pc',
                id: 1
              },
              {
                label: '2件/pcs',
                id: 2
              },
              {
                label: '3件/pcs',
                id: 3
              },
              {
                label: '4件/pcs',
                id: 4
              },
              {
                label: '5件/pcs',
                id: 5
              },
              {
                label: '6件/pcs',
                id: 6
              },
              {
                label: '7件/pcs',
                id: 7
              },
              {
                label: '8件/pcs',
                id: 8
              },
              {
                label: '9件/pcs',
                id: 9
              },
              {
                label: '10件或以上/or more pcs',
                id: 10
              }
            ]
          }
        },
        {
          md: 4,
          propName: 'shelves_rack',
          toplabel: '大層架櫃 Shelves/Rack',
          label: '請選擇數量',
          type: {
            name: 'select',
            items: [
              {
                label: '請選擇數量',
                id: 0
              },
              {
                label: '1件/pc',
                id: 1
              },
              {
                label: '2件/pcs',
                id: 2
              },
              {
                label: '3件/pcs',
                id: 3
              },
              {
                label: '4件/pcs',
                id: 4
              },
              {
                label: '5件/pcs',
                id: 5
              },
              {
                label: '6件/pcs',
                id: 6
              },
              {
                label: '7件/pcs',
                id: 7
              },
              {
                label: '8件/pcs',
                id: 8
              },
              {
                label: '9件/pcs',
                id: 9
              },
              {
                label: '10件或以上/or more pcs',
                id: 10
              }
            ]
          }
        },
        {
          md: 12,
          sectionTitle: '梳化和椅 Sofa & Chair'
        },
        {
          md: 4,
          propName: 'sofa_1',
          toplabel: '梳化 (單座位) Single Sofa',
          label: '請選擇數量',
          type: {
            name: 'select',
            items: [
              {
                label: '請選擇數量',
                id: 0
              },
              {
                label: '1件/pc',
                id: 1
              },
              {
                label: '2件/pcs',
                id: 2
              },
              {
                label: '3件/pcs',
                id: 3
              },
              {
                label: '4件/pcs',
                id: 4
              },
              {
                label: '5件/pcs',
                id: 5
              },
              {
                label: '6件/pcs',
                id: 6
              },
              {
                label: '7件/pcs',
                id: 7
              },
              {
                label: '8件/pcs',
                id: 8
              },
              {
                label: '9件/pcs',
                id: 9
              },
              {
                label: '10件或以上/or more pcs',
                id: 10
              }
            ]
          }
        },
        {
          md: 4,
          propName: 'sofa_2',
          toplabel: '梳化 (兩座位) 2 Seater Sofa',
          label: '請選擇數量',
          type: {
            name: 'select',
            items: [
              {
                label: '請選擇數量',
                id: 0
              },
              {
                label: '1件/pc',
                id: 1
              },
              {
                label: '2件/pcs',
                id: 2
              },
              {
                label: '3件/pcs',
                id: 3
              },
              {
                label: '4件/pcs',
                id: 4
              },
              {
                label: '5件/pcs',
                id: 5
              },
              {
                label: '6件/pcs',
                id: 6
              },
              {
                label: '7件/pcs',
                id: 7
              },
              {
                label: '8件/pcs',
                id: 8
              },
              {
                label: '9件/pcs',
                id: 9
              },
              {
                label: '10件或以上/or more pcs',
                id: 10
              }
            ]
          }
        },
        {
          md: 4,
          propName: 'sofa_3',
          toplabel: '梳化 (三座位) 3 Seater Sofa',
          label: '請選擇數量',
          type: {
            name: 'select',
            items: [
              {
                label: '請選擇數量',
                id: 0
              },
              {
                label: '1件/pc',
                id: 1
              },
              {
                label: '2件/pcs',
                id: 2
              },
              {
                label: '3件/pcs',
                id: 3
              },
              {
                label: '4件/pcs',
                id: 4
              },
              {
                label: '5件/pcs',
                id: 5
              },
              {
                label: '6件/pcs',
                id: 6
              },
              {
                label: '7件/pcs',
                id: 7
              },
              {
                label: '8件/pcs',
                id: 8
              },
              {
                label: '9件/pcs',
                id: 9
              },
              {
                label: '10件或以上/or more pcs',
                id: 10
              }
            ]
          }
        },
        {
          md: 4,
          propName: 'chair_work',
          toplabel: '辦公椅 Work Chair',
          label: '請選擇數量',
          type: {
            name: 'select',
            items: [
              {
                label: '請選擇數量',
                id: 0
              },
              {
                label: '1-10件/pcs',
                id: 1
              },
              {
                label: '11-20件/pcs',
                id: 2
              },
              {
                label: '21-30件/pcs',
                id: 3
              },
              {
                label: '31-40件/pcs',
                id: 4
              },
              {
                label: '41-50件/pcs',
                id: 5
              },
              {
                label: '51-60件/pcs',
                id: 6
              },
              {
                label: '61-70件/pcs',
                id: 7
              },
              {
                label: '71-80件/pcs',
                id: 8
              },
              {
                label: '81-90件/pcs',
                id: 9
              },
              {
                label: '91-100件/pcs',
                id: 10
              },
              {
                label: '100件或以上/or more pcs',
                id: 11
              }
            ]
          }
        },
        {
          md: 4,
          propName: 'chair_floding',
          toplabel: '折椅 Folding Chair',
          label: '請選擇數量',
          type: {
            name: 'select',
            items: [
              {
                label: '請選擇數量',
                id: 0
              },
              {
                label: '1-10件/pcs',
                id: 1
              },
              {
                label: '11-20件/pcs',
                id: 2
              },
              {
                label: '21-30件/pcs',
                id: 3
              },
              {
                label: '31-40件/pcs',
                id: 4
              },
              {
                label: '41-50件/pcs',
                id: 5
              },
              {
                label: '51-60件/pcs',
                id: 6
              },
              {
                label: '61-70件/pcs',
                id: 7
              },
              {
                label: '71-80件/pcs',
                id: 8
              },
              {
                label: '81-90件/pcs',
                id: 9
              },
              {
                label: '91-100件/pcs',
                id: 10
              },
              {
                label: '100件或以上/or more pcs',
                id: 11
              }
            ]
          }
        },
        {
          md: 12,
          sectionTitle: '其他雜物 Others'
        },
        {
          md: 4,
          propName: 'safes',
          toplabel: '夾萬 Safes',
          label: '請選擇數量',
          type: {
            name: 'select',
            items: [
              {
                label: '請選擇數量',
                id: 0
              },
              {
                label: '1件/pc',
                id: 1
              },
              {
                label: '2件/pcs',
                id: 2
              },
              {
                label: '3件/pcs',
                id: 3
              },
              {
                label: '4件/pcs',
                id: 4
              },
              {
                label: '5件/pcs',
                id: 5
              },
              {
                label: '6件/pcs',
                id: 6
              },
              {
                label: '7件/pcs',
                id: 7
              },
              {
                label: '8件/pcs',
                id: 8
              },
              {
                label: '9件/pcs',
                id: 9
              },
              {
                label: '10件或以上/or more pcs',
                id: 10
              }
            ]
          }
        },
        {
          md: 4,
          propName: 'screen',
          toplabel: '屏風 Screen',
          label: '請選擇數量',
          type: {
            name: 'select',
            items: [
              {
                label: '請選擇數量',
                id: 0
              },
              {
                label: '1件/pc',
                id: 1
              },
              {
                label: '2件/pcs',
                id: 2
              },
              {
                label: '3件/pcs',
                id: 3
              },
              {
                label: '4件/pcs',
                id: 4
              },
              {
                label: '5件/pcs',
                id: 5
              },
              {
                label: '6件/pcs',
                id: 6
              },
              {
                label: '7件/pcs',
                id: 7
              },
              {
                label: '8件/pcs',
                id: 8
              },
              {
                label: '9件/pcs',
                id: 9
              },
              {
                label: '10件或以上/or more pcs',
                id: 10
              }
            ]
          }
        },
        {
          md: 4,
          propName: 'copier',
          toplabel: '影印機 Copier',
          label: '請選擇數量',
          type: {
            name: 'select',
            items: [
              {
                label: '請選擇數量',
                id: 0
              },
              {
                label: '1件/pc',
                id: 1
              },
              {
                label: '2件/pcs',
                id: 2
              },
              {
                label: '3件/pcs',
                id: 3
              },
              {
                label: '4件/pcs',
                id: 4
              },
              {
                label: '5件/pcs',
                id: 5
              },
              {
                label: '6件/pcs',
                id: 6
              },
              {
                label: '7件/pcs',
                id: 7
              },
              {
                label: '8件/pcs',
                id: 8
              },
              {
                label: '9件/pcs',
                id: 9
              },
              {
                label: '10件或以上/or more pcs',
                id: 10
              }
            ]
          }
        },
        {
          md: 4,
          propName: 'fax',
          toplabel: '傳真機 Fax',
          label: '請選擇數量',
          type: {
            name: 'select',
            items: [
              {
                label: '請選擇數量',
                id: 0
              },
              {
                label: '1件/pc',
                id: 1
              },
              {
                label: '2件/pcs',
                id: 2
              },
              {
                label: '3件/pcs',
                id: 3
              },
              {
                label: '4件/pcs',
                id: 4
              },
              {
                label: '5件/pcs',
                id: 5
              },
              {
                label: '6件/pcs',
                id: 6
              },
              {
                label: '7件/pcs',
                id: 7
              },
              {
                label: '8件/pcs',
                id: 8
              },
              {
                label: '9件/pcs',
                id: 9
              },
              {
                label: '10件或以上/or more pcs',
                id: 10
              }
            ]
          }
        },
        {
          md: 4,
          propName: 'pc',
          toplabel: '電腦 PC',
          label: '請選擇數量',
          type: {
            name: 'select',
            items: [
              {
                label: '請選擇數量',
                id: 0
              },
              {
                label: '1-10件/pcs',
                id: 1
              },
              {
                label: '11-20件/pcs',
                id: 2
              },
              {
                label: '21-30件/pcs',
                id: 3
              },
              {
                label: '31-40件/pcs',
                id: 4
              },
              {
                label: '41-50件/pcs',
                id: 5
              },
              {
                label: '51-60件/pcs',
                id: 6
              },
              {
                label: '61-70件/pcs',
                id: 7
              },
              {
                label: '71-80件/pcs',
                id: 8
              },
              {
                label: '81-90件/pcs',
                id: 9
              },
              {
                label: '91-100件/pcs',
                id: 10
              },
              {
                label: '100件或以上/or more pcs',
                id: 11
              }
            ]
          }
        },
        {
          md: 4,
          propName: 'server',
          toplabel: '伺服器 Server',
          label: '請選擇數量',
          type: {
            name: 'select',
            items: [
              {
                label: '請選擇數量',
                id: 0
              },
              {
                label: '1件/pc',
                id: 1
              },
              {
                label: '2件/pcs',
                id: 2
              },
              {
                label: '3件/pcs',
                id: 3
              },
              {
                label: '4件/pcs',
                id: 4
              },
              {
                label: '5件/pcs',
                id: 5
              },
              {
                label: '6件/pcs',
                id: 6
              },
              {
                label: '7件/pcs',
                id: 7
              },
              {
                label: '8件/pcs',
                id: 8
              },
              {
                label: '9件/pcs',
                id: 9
              },
              {
                label: '10件或以上/or more pcs',
                id: 10
              }
            ]
          }
        },
        {
          md: 4,
          propName: 'server_case',
          toplabel: '伺服器櫃 Server Case',
          label: '請選擇數量',
          type: {
            name: 'select',
            items: [
              {
                label: '請選擇數量',
                id: 0
              },
              {
                label: '1件/pc',
                id: 1
              },
              {
                label: '2件/pcs',
                id: 2
              },
              {
                label: '3件/pcs',
                id: 3
              },
              {
                label: '4件/pcs',
                id: 4
              },
              {
                label: '5件/pcs',
                id: 5
              },
              {
                label: '6件/pcs',
                id: 6
              },
              {
                label: '7件/pcs',
                id: 7
              },
              {
                label: '8件/pcs',
                id: 8
              },
              {
                label: '9件/pcs',
                id: 9
              },
              {
                label: '10件或以上/or more pcs',
                id: 10
              }
            ]
          }
        },
        {
          md: 4,
          propName: 'refrigerater',
          toplabel: '雪櫃 Refrigerater',
          label: '請選擇數量',
          type: {
            name: 'select',
            items: [
              {
                label: '請選擇數量',
                id: 0
              },
              {
                label: '1件/pc',
                id: 1
              },
              {
                label: '2件/pcs',
                id: 2
              },
              {
                label: '3件/pcs',
                id: 3
              },
              {
                label: '4件/pcs',
                id: 4
              },
              {
                label: '5件/pcs',
                id: 5
              },
              {
                label: '6件/pcs',
                id: 6
              },
              {
                label: '7件/pcs',
                id: 7
              },
              {
                label: '8件/pcs',
                id: 8
              },
              {
                label: '9件/pcs',
                id: 9
              },
              {
                label: '10件或以上/or more pcs',
                id: 10
              }
            ]
          }
        },
        {
          md: 4,
          propName: 'drinking Fountains',
          toplabel: '飲水機 Drinking Fountains',
          label: '請選擇數量',
          type: {
            name: 'select',
            items: [
              {
                label: '請選擇數量',
                id: 0
              },
              {
                label: '1件/pc',
                id: 1
              },
              {
                label: '2件/pcs',
                id: 2
              },
              {
                label: '3件/pcs',
                id: 3
              },
              {
                label: '4件/pcs',
                id: 4
              },
              {
                label: '5件/pcs',
                id: 5
              },
              {
                label: '6件/pcs',
                id: 6
              },
              {
                label: '7件/pcs',
                id: 7
              },
              {
                label: '8件/pcs',
                id: 8
              },
              {
                label: '9件/pcs',
                id: 9
              },
              {
                label: '10件或以上/or more pcs',
                id: 10
              }
            ]
          }
        },
        {
          md: 4,
          propName: 'microwave Oven',
          toplabel: '微波爐 Microwave Oven',
          label: '請選擇數量',
          type: {
            name: 'select',
            items: [
              {
                label: '請選擇數量',
                id: 0
              },
              {
                label: '1件/pc',
                id: 1
              },
              {
                label: '2件/pcs',
                id: 2
              },
              {
                label: '3件/pcs',
                id: 3
              },
              {
                label: '4件/pcs',
                id: 4
              },
              {
                label: '5件/pcs',
                id: 5
              },
              {
                label: '6件/pcs',
                id: 6
              },
              {
                label: '7件/pcs',
                id: 7
              },
              {
                label: '8件/pcs',
                id: 8
              },
              {
                label: '9件/pcs',
                id: 9
              },
              {
                label: '10件或以上/or more pcs',
                id: 10
              }
            ]
          }
        },
        {
          md: 4,
          propName: 'tv',
          toplabel: '電視機 TV',
          label: '請選擇數量',
          type: {
            name: 'select',
            items: [
              {
                label: '請選擇數量',
                id: 0
              },
              {
                label: '1件/pc',
                id: 1
              },
              {
                label: '2件/pcs',
                id: 2
              },
              {
                label: '3件/pcs',
                id: 3
              },
              {
                label: '4件/pcs',
                id: 4
              },
              {
                label: '5件/pcs',
                id: 5
              },
              {
                label: '6件/pcs',
                id: 6
              },
              {
                label: '7件/pcs',
                id: 7
              },
              {
                label: '8件/pcs',
                id: 8
              },
              {
                label: '9件/pcs',
                id: 9
              },
              {
                label: '10件或以上/or more pcs',
                id: 10
              }
            ]
          }
        },
        {
          md: 4,
          propName: 'dehumidifier',
          toplabel: '抽濕機 Dehumidifier',
          label: '請選擇數量',
          type: {
            name: 'select',
            items: [
              {
                label: '請選擇數量',
                id: 0
              },
              {
                label: '1件/pc',
                id: 1
              },
              {
                label: '2件/pcs',
                id: 2
              },
              {
                label: '3件/pcs',
                id: 3
              },
              {
                label: '4件/pcs',
                id: 4
              },
              {
                label: '5件/pcs',
                id: 5
              },
              {
                label: '6件/pcs',
                id: 6
              },
              {
                label: '7件/pcs',
                id: 7
              },
              {
                label: '8件/pcs',
                id: 8
              },
              {
                label: '9件/pcs',
                id: 9
              },
              {
                label: '10件或以上/or more pcs',
                id: 10
              }
            ]
          }
        },
        {
          md: 4,
          propName: 'lamp_floor',
          toplabel: '坐地燈 Floor Lamp',
          label: '請選擇數量',
          type: {
            name: 'select',
            items: [
              {
                label: '請選擇數量',
                id: 0
              },
              {
                label: '1件/pc',
                id: 1
              },
              {
                label: '2件/pcs',
                id: 2
              },
              {
                label: '3件/pcs',
                id: 3
              },
              {
                label: '4件/pcs',
                id: 4
              },
              {
                label: '5件/pcs',
                id: 5
              },
              {
                label: '6件/pcs',
                id: 6
              },
              {
                label: '7件/pcs',
                id: 7
              },
              {
                label: '8件/pcs',
                id: 8
              },
              {
                label: '9件/pcs',
                id: 9
              },
              {
                label: '10件或以上/or more pcs',
                id: 10
              }
            ]
          }
        },
        {
          md: 4,
          propName: 'fish_tank',
          toplabel: '魚缸 Fish Tank',
          label: '請選擇數量',
          type: {
            name: 'select',
            items: [
              {
                label: '請選擇數量',
                id: 0
              },
              {
                label: '1件/pc',
                id: 1
              },
              {
                label: '2件/pcs',
                id: 2
              },
              {
                label: '3件/pcs',
                id: 3
              },
              {
                label: '4件/pcs',
                id: 4
              },
              {
                label: '5件/pcs',
                id: 5
              },
              {
                label: '6件/pcs',
                id: 6
              },
              {
                label: '7件/pcs',
                id: 7
              },
              {
                label: '8件/pcs',
                id: 8
              },
              {
                label: '9件/pcs',
                id: 9
              },
              {
                label: '10件或以上/or more pcs',
                id: 10
              }
            ]
          }
        },
        {
          md: 4,
          propName: 'painting',
          toplabel: '畫 Painting',
          label: '請選擇數量',
          type: {
            name: 'select',
            items: [
              {
                label: '請選擇數量',
                id: 0
              },
              {
                label: '1件/pc',
                id: 1
              },
              {
                label: '2件/pcs',
                id: 2
              },
              {
                label: '3件/pcs',
                id: 3
              },
              {
                label: '4件/pcs',
                id: 4
              },
              {
                label: '5件/pcs',
                id: 5
              },
              {
                label: '6件/pcs',
                id: 6
              },
              {
                label: '7件/pcs',
                id: 7
              },
              {
                label: '8件/pcs',
                id: 8
              },
              {
                label: '9件/pcs',
                id: 9
              },
              {
                label: '10件或以上/or more pcs',
                id: 10
              }
            ]
          }
        },
        {
          md: 4,
          propName: 'table_coffee',
          toplabel: '茶几 Coffee Table',
          label: '請選擇數量',
          type: {
            name: 'select',
            items: [
              {
                label: '請選擇數量',
                id: 0
              },
              {
                label: '1件/pc',
                id: 1
              },
              {
                label: '2件/pcs',
                id: 2
              },
              {
                label: '3件/pcs',
                id: 3
              },
              {
                label: '4件/pcs',
                id: 4
              },
              {
                label: '5件/pcs',
                id: 5
              },
              {
                label: '6件/pcs',
                id: 6
              },
              {
                label: '7件/pcs',
                id: 7
              },
              {
                label: '8件/pcs',
                id: 8
              },
              {
                label: '9件/pcs',
                id: 9
              },
              {
                label: '10件或以上/or more pcs',
                id: 10
              }
            ]
          }
        },
        {
          md: 4,
          propName: 'plans',
          toplabel: '植物 Plants',
          label: '請選擇數量',
          type: {
            name: 'select',
            items: [
              {
                label: '請選擇數量',
                id: 0
              },
              {
                label: '1件/pc',
                id: 1
              },
              {
                label: '2件/pcs',
                id: 2
              },
              {
                label: '3件/pcs',
                id: 3
              },
              {
                label: '4件/pcs',
                id: 4
              },
              {
                label: '5件/pcs',
                id: 5
              },
              {
                label: '6件/pcs',
                id: 6
              },
              {
                label: '7件/pcs',
                id: 7
              },
              {
                label: '8件/pcs',
                id: 8
              },
              {
                label: '9件/pcs',
                id: 9
              },
              {
                label: '10件或以上/or more pcs',
                id: 10
              }
            ]
          }
        },
        {
          md: 4,
          propName: 'whiteBoard',
          toplabel: '白板 White board',
          label: '請選擇數量',
          type: {
            name: 'select',
            items: [
              {
                label: '請選擇數量',
                id: 0
              },
              {
                label: '1件/pc',
                id: 1
              },
              {
                label: '2件/pcs',
                id: 2
              },
              {
                label: '3件/pcs',
                id: 3
              },
              {
                label: '4件/pcs',
                id: 4
              },
              {
                label: '5件/pcs',
                id: 5
              },
              {
                label: '6件/pcs',
                id: 6
              },
              {
                label: '7件/pcs',
                id: 7
              },
              {
                label: '8件/pcs',
                id: 8
              },
              {
                label: '9件/pcs',
                id: 9
              },
              {
                label: '10件或以上/or more pcs',
                id: 10
              }
            ]
          }
        },
        {
          md: 4,
          propName: 'plastic Bags',
          toplabel: '膠箱/盒 Plastic Bags',
          label: '請選擇數量',
          type: {
            name: 'select',
            items: [
              {
                label: '請選擇數量',
                id: 0
              },
              {
                label: '1-20件/pcs',
                id: 1
              },
              {
                label: '21-40件/pcs',
                id: 2
              },
              {
                label: '41-60件/pcs',
                id: 3
              },
              {
                label: '61-80件/pcs',
                id: 4
              },
              {
                label: '81-100件/pcs',
                id: 5
              },
              {
                label: '101-150件/pcs',
                id: 6
              },
              {
                label: '151-200件/pcs',
                id: 7
              },
              {
                label: '201-250件/pcs',
                id: 8
              },
              {
                label: '251-300件/pcs',
                id: 9
              },
              {
                label: '300-500件/pcs',
                id: 10
              },
              {
                label: '500件或以上/or more pcs',
                id: 11
              }
            ]
          }
        },
        {
          md: 4,
          propName: 'carton Box',
          toplabel: '紙箱 Carton Box',
          label: '請選擇數量',
          type: {
            name: 'select',
            items: [
              {
                label: '請選擇數量',
                id: 0
              },
              {
                label: '1-20件/pcs',
                id: 1
              },
              {
                label: '21-40件/pcs',
                id: 2
              },
              {
                label: '41-60件/pcs',
                id: 3
              },
              {
                label: '61-80件/pcs',
                id: 4
              },
              {
                label: '81-100件/pcs',
                id: 5
              },
              {
                label: '101-150件/pcs',
                id: 6
              },
              {
                label: '151-200件/pcs',
                id: 7
              },
              {
                label: '201-250件/pcs',
                id: 8
              },
              {
                label: '251-300件/pcs',
                id: 9
              },
              {
                label: '300-500件/pcs',
                id: 10
              },
              {
                label: '500件或以上/or more pcs',
                id: 11
              }
            ]
          }
        },
        {
          md: 6,
          offsetRightMd: 6,
          propName: 'other Items',
          toplabel: '其他物件 (請特別註明) Other Items (Please Specify)',
          type: {
            name: 'textarea'
          }
        }
      ]
    }
  }
}
</script>
